import React, { Component, Fragment } from 'react'
import { withStyles } from "@material-ui/styles";
import { Link, withRouter } from 'react-router-dom'
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box'; 
import MaterialTable, { MTableToolbar } from 'material-table';
import Divider from '@material-ui/core/Divider';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import PageTitle from '../../../components/PageTitle/PageTitle';
import GridContainer from '../../../components/Custom/Grid/GridContainer';
import GridItem from '../../../components/Custom/Grid/GridItem';
import TableIconsComponent from '../../../components/TableLogo/TableIconsComponent';
import ApiService, { showToast, Status } from '../../ApiService/ApiService';
import { BLOCK_CARD_GET_ALL, BLOCK_CARD_ADD, BLOCK_CARD_REMOVE } from '../../ApiService/URLs';

import ObjectUtils from '../../../util/objectUtil';
import CustomInput from '../../../components/Custom/CustomInput/CustomInput';
import Button from '../../../components/Custom/Button/Button';

const useStyles = theme => ({
  theme: theme,
  searchbar: {
	margin: theme.spacing(2),
  },
  formControl: {
    minWidth: 200,
  },

});

class CardBlockComponent extends Component {

	constructor(props) {
		 super(props)
		 this.state = {
			blockCards : [],
			responsemessage: null,
			card: null,
			blockCardValidation: {}
		}
	 	this.handleChange = this.handleChange.bind(this);
		this.reloadData = this.reloadData.bind(this);
		this.blockCard = this.blockCard.bind(this);
	}

	handleChange(event) {
        this.setState({[event.target.name]: event.target.value, critChanged: true })
    }

	componentDidMount() {
		this.reloadData();
	}

	reloadData() {
		ApiService.postAPI(BLOCK_CARD_GET_ALL, {merchantId : this.props.merchantId}).then((res) => { 
			if (res != null) {
				if(res.data.status === "success") {
					res.data.data.map (card => card.cardNo = card.cardFirstSix.slice(0, 4) + 
										"-" + card.cardFirstSix.slice(-2) + "xx-xxxx-" + card.cardEndFour);
					this.setState({blockCards: res.data.data});
				} else {
					showToast({ type: Status.ERROR, title: "Error", description: res.data.statusText });
				}
			}
		});
	}
	
	blockCard() {
		if (ObjectUtils.isNullorEmpty(this.state.card)) {
			this.setState ({blockCardValidation : {helperType : Status.ERROR, helperText: "Card is required"}});
			return;
		}
		
		if (this.state.card.length !== 16)	{
			this.setState ({blockCardValidation : {helperType : Status.ERROR, helperText: "Card is invalid"}});
			return;
		}
		
		const reqObj = {
			merchantId : this.props.merchantId,
			cardFirstSix: this.state.card.slice(0, 6),
			cardEndFour: this.state.card.slice(-4),
		};

		ApiService.postAPI(BLOCK_CARD_ADD, reqObj).then((res) => {
			if (res != null) {
				if(res.data.status === "success") {
					showToast({ type: Status.SUCCESS, title: "Add", description: res.data.message });
					this.setState ({card: "", blockCardValidation : {}}, () => this.reloadData());
				} else {
					showToast({ type: Status.ERROR, title: "Error", description: res.data.message });
				}
			}
		});
	}

	unblockCard(data) {
		const reqObj = { merchantId : this.props.merchantId, id: data.id };
		ApiService.postAPI(BLOCK_CARD_REMOVE, reqObj).then((res) => {
			if (res != null) {
				if(res.data.status === "success") {
					this.reloadData();
					showToast({ type: Status.SUCCESS, title: "Delete", description: res.data.message });
				} else {
					showToast({ type: Status.ERROR, title: "Error", description: res.data.message });
				}
			}
		});
	}

    render() {
        const { classes } = this.props; 
		const { card, blockCardValidation } = this.state; 
	 
        return (<>
				<GridContainer>
					<GridItem xs={8} sm={9} md={5} lg={4}>
						<CustomInput title="Credit card number" field="card"
							formControlProps={{ fullWidth: true }}
							inputProps={{
								value: card,
								name: "card",
								onChange: this.handleChange
							}}
							helperType={blockCardValidation.helperType}
							helperText={blockCardValidation.helperText}
						/>
					</GridItem>
					<GridItem xs={4} sm={3} md={7} lg={8}>
						<Button variant="contained" className={classes.searchbar} color="primary" size="sm" onClick={this.blockCard}>
							Block Card
						</Button>
					</GridItem>
				</GridContainer>
				<Divider/>
				<GridContainer>
					<GridItem xs={12} sm={12} md={12} lg={12}>
						<>
							<MaterialTable 
							title="Blocked Cards"
							icons={TableIconsComponent.icons}
							columns={[ 
								{ field: 'cardNo', numeric: false, title: 'Card No'},
							]}
							data={this.state.blockCards}
							actions={[						
								{
									tooltip: 'Unblock Card',
									icon: (props)=> <DeleteIcon {...props} />,
									onClick: (evt, data) => this.unblockCard(data),
								}
							]}
							options={{
								headerStyle: { 
									whiteSpace: 'nowrap', backgroundColor: "#fff", 
									color: "#000", fontSize: 12
								},
								search:false,
								exportButton: false,
								pageSize: 10,
								pageSizeOptions: [10,20],
								padding: 'dense',
								showEmptyDataSourceMessage: true,
								emptyRowsWhenPaging: false,
							}}				     
							/>
						</>
				 	</GridItem>
				</GridContainer>
			 </>)
    }
}

export default withStyles(useStyles)(CardBlockComponent)
